import { Helmet } from 'react-helmet-async'
import { ContactForm } from '@/components/support/ContactForm'
import { OG_IMAGE_URL, siteUrl } from '@/lib/config/site'

export default function SupportPage() {
  return (
    <div className="min-h-screen p-6 sm:p-8 flex items-center justify-center">
      <Helmet>
        <title>Support - Footage</title>
        <meta name="description" content="Get help with Footage. Browse FAQs and contact support." />
        <link rel="canonical" href={siteUrl('/support')} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Support - Footage" />
        <meta property="og:description" content="Get help with Footage. Browse FAQs and contact support." />
        <meta property="og:url" content={siteUrl('/support')} />
        <meta property="og:image" content={OG_IMAGE_URL} />
        <meta property="og:site_name" content="Footage" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Support - Footage" />
        <meta name="twitter:description" content="Get help with Footage. Browse FAQs and contact support." />
        <meta name="twitter:image" content={OG_IMAGE_URL} />
      </Helmet>
      <div className="w-full max-w-3xl">
        <ContactForm />
      </div>
    </div>
  )
}
